import { isClient as o } from "./index42.mjs";
const l = (r, m = {
  parser: (e) => JSON.parse(e),
  stringifier: (e) => JSON.stringify(e)
}) => ({
  setItem: (t) => {
    o() && localStorage.setItem(r, m.stringifier(t));
  },
  getItem: () => {
    if (o()) {
      const t = localStorage.getItem(r);
      return t ? m.parser(t) : null;
    }
    return null;
  },
  removeItem: () => {
    o() && localStorage.removeItem(r);
  }
});
export {
  l as useStorage
};
